export default function formatPriceRange(priceRangeArray, indexOfPrice) {
  let result = '';
  /* istanbul ignore else */
  if (
    Array.isArray(priceRangeArray)
    && priceRangeArray.length > indexOfPrice
    && indexOfPrice >= 0
  ) {
    const price = priceRangeArray[indexOfPrice].toString();
    const idx = price.lastIndexOf('-');
    /* istanbul ignore else */
    if (idx > -1) {
      result = `$${price.substr(0, idx + 1)}$${price.substr(idx + 1)}`;
    }
  }

  return result;
}
